// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"styles_inputNumber__26TAK","inputString":"styles_inputString__LZvyl"};